import React from 'react'
import { useRouter } from 'next/router'

import { useAPIGetPraktikKinerjaFormValues } from 'api/kinerja/penilik-pegawai/pelaksanaan/form'

import type { StatusPelaksanaanPraktikKinerja } from 'types/kinerja-penilik-pegawai'

type PelaksanaanPraktikKinerja = {
  state: StatusPelaksanaanPraktikKinerja
}
export const usePelaksanaanPraktikKinerja = ({
  state,
}: PelaksanaanPraktikKinerja) => {
  const router = useRouter()
  const skpId = router.query?.skpId as string
  const { data: diskusiPersiapanFormData, isLoading: diskusiPersiapanLoading } =
    useAPIGetPraktikKinerjaFormValues({
      skpId,
      formName: 'diskusi_persiapan',
      opts: {
        enabled:
          Boolean(skpId) &&
          ['DISKUSI_PERSIAPAN', 'PENDAMPINGAN_SEKOLAH'].includes(state),
      },
    })
  const isDiskusiPersiapanFormSubmitted = React.useMemo(
    () =>
      Object.keys(JSON.parse(diskusiPersiapanFormData?.formValues ?? '{}'))
        .length > 0,
    [diskusiPersiapanFormData?.formValues]
  )

  const {
    data: pendampinganSekolahFormData,
    isLoading: pendampinganSekolahLoading,
  } = useAPIGetPraktikKinerjaFormValues({
    skpId,
    formName: 'pendampingan_sekolah',
    opts: {
      enabled:
        Boolean(skpId) &&
        ['DISKUSI_PERSIAPAN', 'PENDAMPINGAN_SEKOLAH'].includes(state),
    },
  })
  const isPendampinganSekolahFormSubmitted = React.useMemo(
    () =>
      Object.keys(JSON.parse(pendampinganSekolahFormData?.formValues ?? '{}'))
        .length > 0,
    [pendampinganSekolahFormData?.formValues]
  )

  const isLoading = React.useMemo(
    () => diskusiPersiapanLoading || pendampinganSekolahLoading,
    [diskusiPersiapanLoading, pendampinganSekolahLoading]
  )

  return {
    isDiskusiPersiapanFormSubmitted,
    isPendampinganSekolahFormSubmitted,

    diskusiPersiapanLoading,
    pendampinganSekolahLoading,
    isLoading,
  }
}
